import type { SVGProps } from 'react';

const PdfIcon = (props: SVGProps<SVGSVGElement>) => (
   <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
   >
      <path
         d="M3 3V29C3 30.6569 4.34315 32 6 32H26C27.6569 32 29 30.6569 29 29V12L17 0H6C4.34315 0 3 1.34315 3 3Z"
         fill="#FF6860"
      />
      <path d="M17 0L29 12H20C18.3431 12 17 10.6569 17 9V0Z" fill="#D93531" />
      <path
         d="M9.95508 22.5V25H8.51953V17.8906H10.9414C11.6445 17.8906 12.2044 18.1087 12.6211 18.5449C13.041 18.9811 13.251 19.5475 13.251 20.2441C13.251 20.9408 13.0443 21.4909 12.6309 21.8945C12.2174 22.2982 11.6445 22.5 10.9121 22.5H9.95508ZM9.95508 21.3037H10.9414C11.2148 21.3037 11.4264 21.2142 11.5762 21.0352C11.7259 20.8561 11.8008 20.5957 11.8008 20.2539C11.8008 19.8991 11.7243 19.6175 11.5713 19.4092C11.4183 19.1976 11.2132 19.0902 10.9561 19.0869H9.95508V21.3037ZM14.2129 25V17.8906H16.0928C16.9229 17.8906 17.5837 18.1543 18.0752 18.6816C18.57 19.209 18.8223 19.9316 18.832 20.8496V22.002C18.832 22.9362 18.5846 23.6702 18.0898 24.2041C17.5983 24.7347 16.9196 25 16.0537 25H14.2129ZM15.6484 19.0869V23.8086H16.0781C16.5566 23.8086 16.8936 23.6833 17.0889 23.4326C17.2842 23.1787 17.3867 22.7425 17.3965 22.124V20.8887C17.3965 20.2246 17.3037 19.7624 17.1182 19.502C16.9326 19.2383 16.6169 19.0999 16.1709 19.0869H15.6484ZM23.5342 22.0996H21.3027V25H19.8672V17.8906H23.8027V19.0869H21.3027V20.9082H23.5342V22.0996Z"
         fill="white"
      />
   </svg>
);

export default PdfIcon;
